import React from "react";
import { Box, Button, Typography } from "@mui/material";
import HealingIcon from "@mui/icons-material/Healing";
import SearchOffIcon from "@mui/icons-material/SearchOff";

/**
 * Friendly empty-state placeholders for the Requests list.
 * Variant "no_data" — never had any requests (point user at CSPM).
 * Variant "no_match" — filters returned nothing.
 */
const EmptyState = ({ variant, onClearFilters }) => {
  if (variant === "no_match") {
    return (
      <Box
        sx={{
          py: 6,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          color: "text.secondary",
        }}
      >
        <SearchOffIcon sx={{ fontSize: 48, mb: 1, color: "grey.400" }} />
        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5 }}>
          No tasks match these filters.
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Try removing a filter chip or clearing your search.
        </Typography>
        {onClearFilters && (
          <Button variant="outlined" size="small" onClick={onClearFilters}>
            Clear filters
          </Button>
        )}
      </Box>
    );
  }
  return (
    <Box
      sx={{
        py: 6,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        color: "text.secondary",
        textAlign: "center",
      }}
    >
      <HealingIcon sx={{ fontSize: 48, mb: 1, color: "grey.400" }} />
      <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5 }}>
        No remediation tasks yet
      </Typography>
      <Typography variant="body2" sx={{ maxWidth: 460 }}>
        File a task from the CSPM page — click <strong>File task</strong> on any check that
        has a "Remediate now" pill.
      </Typography>
    </Box>
  );
};

export default EmptyState;
